<div class="Dialog" mat-dialog-content>
  <div>
    <p>The selected {{ attribute }} is not available based on your current configuration.</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close] class="ThemeColorAccent">Ok</button>
  </mat-dialog-actions>
</div>